export const SEARCH_INITIAL_PAGINATION_SIZE = 20;
export const SEARCH_NEXT_PAGINATION_SIZE = 10;
